import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { selectMetricDataForContentItem } from '../selectors';
import { MetricCard, MetricCardOwnProps, MetricCardStateProps } from './MetricCard';

const mapStateToProps: MapStateToProps<MetricCardStateProps> = (state: AppState, ownProps: MetricCardOwnProps) => {
  return {
    metricData: selectMetricDataForContentItem(state, ownProps.content),
  };
};

export const ConnectedMetricCard: React.ComponentClass<MetricCardOwnProps> = connect(mapStateToProps, undefined)(MetricCard);
